import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import dayjs from 'dayjs';
import { Box, Stack } from '@mui/material';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { DailyNoAttendanceStudentsTableHeader } from './DailyTableHeader';
import { getDailyNoAttendanceStudents } from '../../../../redux/features/crdMigrationSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import DatePickerCustom from '../../../../components/DatePicker/DatePickerCustom';

const DailyNoAttendanceStudentsLanding = () => {
  const [todayDate, setTodayDate] = useState(dayjs().format('YYYY-MM-DD'));
  const { loading, data, meta } = useSelector((state) => state.crdMigration.dailyNoAttendanceStudentsTable);
  const dispatch = useDispatch();
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const dispatchParams = useMemo(() => {
    return {
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      sortBy: tableState?.sort?.field,
      sortDirection: tableState?.sort?.direction,
      last_session_date: todayDate,
      cro_id: null,
    };
  }, [tableState?.page, tableState?.pageSize, tableState?.search, tableState?.sort, todayDate]);

  useEffect(() => {
    dispatch(getDailyNoAttendanceStudents(dispatchParams));
  }, [dispatch, dispatchParams]);

  return (
    <GlobalWrapper title={'Daily Not Marked Attendance in Active Students'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
        <DatePickerCustom
          fullWidth={true}
          value={dayjs(todayDate)}
          setValue={(date) => setTodayDate(date.format('YYYY-MM-DD'))}
          viewDetails={['year', 'month', 'day']}
          error={false}
        />
      </Stack>
      <Box mt={1}>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={DailyNoAttendanceStudentsTableHeader()}
          rows={data}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          meta={meta}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default DailyNoAttendanceStudentsLanding;
